var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 48,
    viewBox: "0 0 24 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 48L7.92 39.96L1.38 35.1H9.48L10.98 29.28L2.58 24.36C1.78 23.88 1.15 23.26 0.69 22.5C0.23 21.74 0 20.9 0 19.98V0H24V19.98C24 20.9 23.77 21.74 23.31 22.5C22.85 23.26 22.22 23.88 21.42 24.36L12.96 29.28L14.52 35.1H22.56L16.02 39.96L18.54 48L12 43.14L5.4 48ZM10.44 3.6V24.6L12.24 25.68L14.04 24.6V3.6H10.44Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVReward);
export default __webpack_public_path__ + "static/media/vReward.656f7bcb6f4044dd1deaedb5323a1d86.svg";
export { ForwardRef as ReactComponent };